import {
    FETCH_ADDITIONAL_PRODUCT
} from "../actions/types";

export const reducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_ADDITIONAL_PRODUCT:
            return { ...state, pageAdditionalProduct: action.payload };
        default:
            return state;
    }
};
